/**
 * @generated SignedSource<<bac689feadde1863013ef74c4578bd43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BannersDismissIllustrationMutation$variables = {
  streamId: string;
};
export type BannersDismissIllustrationMutation$data = {
  readonly dismissAutomationTimeSaverIllustration: {
    readonly stream: {
      readonly viewerDismissedAutomationTimeSaverIllustration: boolean;
    };
  } | null;
};
export type BannersDismissIllustrationMutation = {
  response: BannersDismissIllustrationMutation$data;
  variables: BannersDismissIllustrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "streamId",
    "variableName": "streamId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerDismissedAutomationTimeSaverIllustration",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BannersDismissIllustrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DismissAutomationTimeSaverIllustration",
        "kind": "LinkedField",
        "name": "dismissAutomationTimeSaverIllustration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BannersDismissIllustrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DismissAutomationTimeSaverIllustration",
        "kind": "LinkedField",
        "name": "dismissAutomationTimeSaverIllustration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8a13d36e82c0335853ec546d2e418f1b",
    "id": null,
    "metadata": {},
    "name": "BannersDismissIllustrationMutation",
    "operationKind": "mutation",
    "text": "mutation BannersDismissIllustrationMutation(\n  $streamId: ID!\n) {\n  dismissAutomationTimeSaverIllustration(streamId: $streamId) {\n    stream {\n      viewerDismissedAutomationTimeSaverIllustration\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7afd8ae59b222f869039734ee7e1c072";

export default node;
